/* Dabi Deri - ortak hareket sistemi. Tek observer, harici kutuphane yok.

   .dabi-reveal              eski sinif (yerinde duruyor)
   [data-dabi-motion]        rise | fade | scale | slide-start | slide-end
   [data-dabi-stagger]       cocuklardaki [data-dabi-motion] sirayla girer

   Emniyet: gozlemci yoksa, hareket azaltilmissa ya da 4 sn icinde gorunur
   alandaki bir oge hala gizliyse icerik dogrudan gosterilir; hicbir icerik
   animasyon yuzunden gorunmez kalmaz. */
(() => {
  const SELECTOR = '.dabi-reveal, [data-dabi-motion]';
  const showAll = (root = document) => root.querySelectorAll(SELECTOR).forEach((el) => el.classList.add('is-visible'));

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    showAll();
    document.addEventListener('shopify:section:load', (event) => showAll(event.target));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const observe = (root = document) => {
    root.querySelectorAll('[data-dabi-stagger]').forEach((group) => {
      Array.from(group.querySelectorAll('[data-dabi-motion]')).forEach((el, i) => el.style.setProperty('--dabi-motion-i', String(Math.min(i, 8))));
    });
    root.querySelectorAll(SELECTOR).forEach((el) => { if (!el.classList.contains('is-visible')) io.observe(el); });
  };

  observe();

  // Emniyet: gozlemci bir nedenle tetiklenmezse (arka plan sekmesi, eski
  // WebView) gorunur alandaki gizli ogeler yine de gosterilir. Ilk yuklemede
  // ve kaydirma durdugunda calisir; is bitince dinleyici kaldirilir.
  const sweep = () => {
    let left = 0;
    document.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.classList.contains('is-visible')) return;
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      else left += 1;
    });
    return left;
  };
  let sweepTimer = null;
  const onScroll = () => {
    window.clearTimeout(sweepTimer);
    sweepTimer = window.setTimeout(() => {
      if (sweep() === 0) window.removeEventListener('scroll', onScroll);
    }, 400);
  };
  window.setTimeout(sweep, 4000);
  window.addEventListener('scroll', onScroll, { passive: true });

  // Tema duzenleyicide bolum yeniden yuklenince yeni ogeler de baglansin.
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  // Sonradan eklenen icerik (daha fazla goster, filtre) icin disaridan cagrilabilir.
  window.DabiMotion = { observe, showAll };
})();
